export default "__VITE_ASSET__kcG0RHUw__"